export default __webpack_public_path__ + "static/DSC_0119-66dc3522c37c2c07deb51c982e49fa2c.jpg";